module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.name == 'activities') ? _c('svg', {
    staticClass: "icon-svg feather feather-dribbble",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24px",
      "height": "24px",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8.56 2.75c4.37 6.03 6.02 9.42 8.03 17.72m2.54-15.38c-3.72 4.35-8.94 5.66-16.88 5.85m19.5 1.9c-3.5-.93-6.63-.82-8.94 0-2.58.92-5.01 2.86-7.44 6.32"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'alert-triangle') ? _c('svg', {
    staticClass: "feather feather-alert-triangle",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "9",
      "x2": "12",
      "y2": "13"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "17",
      "x2": "12.01",
      "y2": "17"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'archive') ? _c('svg', {
    staticClass: "feather feather-archive",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "21 8 21 21 3 21 3 8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "1",
      "y": "3",
      "width": "22",
      "height": "5"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "10",
      "y1": "12",
      "x2": "14",
      "y2": "12"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'bars') ? _c('svg', {
    staticClass: "feather feather-bar-chart-2",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('line', {
    attrs: {
      "x1": "18",
      "y1": "20",
      "x2": "18",
      "y2": "10"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "20",
      "x2": "12",
      "y2": "4"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "6",
      "y1": "20",
      "x2": "6",
      "y2": "14"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'bell') ? _c('svg', {
    staticClass: "feather feather-bell",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M13.73 21a2 2 0 0 1-3.46 0"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'briefcase') ? _c('svg', {
    staticClass: "feather feather-briefcase",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24px",
      "height": "24px",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('rect', {
    attrs: {
      "data-v-4c034fe6": "",
      "x": "2",
      "y": "7",
      "width": "20",
      "height": "14",
      "rx": "2",
      "ry": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "data-v-4c034fe6": "",
      "d": "M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'calendar') ? _c('svg', {
    staticClass: "feather feather-calendar",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "4",
      "width": "18",
      "height": "18",
      "rx": "2",
      "ry": "2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "2",
      "x2": "16",
      "y2": "6"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "2",
      "x2": "8",
      "y2": "6"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "3",
      "y1": "10",
      "x2": "21",
      "y2": "10"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'cancel') ? _c('svg', {
    staticClass: "feather feather-cancel",
    class: _vm.classname,
    attrs: {
      "data-v-4c034fe6": "",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24px",
      "height": "24px",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('line', {
    attrs: {
      "data-v-4c034fe6": "",
      "x1": "18",
      "y1": "6",
      "x2": "6",
      "y2": "18"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "data-v-4c034fe6": "",
      "x1": "6",
      "y1": "6",
      "x2": "18",
      "y2": "18"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'chart') ? _c('svg', {
    staticClass: "feather feather-pie-chart",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M21.21 15.89A10 10 0 1 1 8 2.83"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22 12A10 10 0 0 0 12 2v10z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'check') ? _c('svg', {
    staticClass: "feather feather-check",
    class: _vm.classname,
    attrs: {
      "data-v-4c034fe6": "",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24px",
      "height": "24px",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "data-v-4c034fe6": "",
      "points": "20 6 9 17 4 12"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'check-circle') ? _c('svg', {
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z",
      "clip-rule": "evenodd"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'chevron-down') ? _c('svg', {
    staticClass: "feather feather-chevron-down",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "6 9 12 15 18 9"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'chevron-left') ? _c('svg', {
    staticClass: "feather feather-chevron-left",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "data-v-4c034fe6": "",
      "points": "15 18 9 12 15 6"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'chevron-right') ? _c('svg', {
    staticClass: "feather feather-chevron-right",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "9 18 15 12 9 6"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'chevrons-left') ? _c('svg', {
    staticClass: "feather feather-chevrons-left",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "11 17 6 12 11 7"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "18 17 13 12 18 7"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'chevrons-right') ? _c('svg', {
    staticClass: "feather feather-chevrons-right",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "13 17 18 12 13 7"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "6 17 11 12 6 7"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'circle-plus') ? _c('svg', {
    staticClass: "feather feather-plus-circle",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "8",
      "x2": "12",
      "y2": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "12",
      "x2": "16",
      "y2": "12"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'clipboard') ? _c('svg', {
    class: _vm.classname,
    attrs: {
      "viewBox": "0 0 24 24",
      "width": "24",
      "height": "24",
      "stroke": "currentColor",
      "stroke-width": "2",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "8",
      "y": "2",
      "width": "8",
      "height": "4",
      "rx": "1",
      "ry": "1"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'clock') ? _c('svg', {
    staticClass: "feather feather-clock",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "12 6 12 12 16 14"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'code') ? _c('svg', {
    staticClass: "icon-svg feather feather-code",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "data-v-4c034fe6": "",
      "points": "16 18 22 12 16 6"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "data-v-4c034fe6": "",
      "points": "8 6 2 12 8 18"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'copy') ? _c('svg', {
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M8.25 7.5V6.108c0-1.135.845-2.098 1.976-2.192.373-.03.748-.057 1.123-.08M15.75 18H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08M15.75 18.75v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5A3.375 3.375 0 006.375 7.5H5.25m11.9-3.664A2.251 2.251 0 0015 2.25h-1.5a2.251 2.251 0 00-2.15 1.586m5.8 0c.065.21.1.433.1.664v.75h-6V4.5c0-.231.035-.454.1-.664M6.75 7.5H4.875c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V16.5a9 9 0 00-9-9z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'cpu') ? _c('svg', {
    class: _vm.classname,
    attrs: {
      "viewBox": "0 0 24 24",
      "width": "24",
      "height": "24",
      "stroke": "currentColor",
      "stroke-width": "2",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('rect', {
    attrs: {
      "x": "4",
      "y": "4",
      "width": "16",
      "height": "16",
      "rx": "2",
      "ry": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "9",
      "y": "9",
      "width": "6",
      "height": "6"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "9",
      "y1": "1",
      "x2": "9",
      "y2": "4"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "15",
      "y1": "1",
      "x2": "15",
      "y2": "4"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "9",
      "y1": "20",
      "x2": "9",
      "y2": "23"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "15",
      "y1": "20",
      "x2": "15",
      "y2": "23"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "20",
      "y1": "9",
      "x2": "23",
      "y2": "9"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "20",
      "y1": "14",
      "x2": "23",
      "y2": "14"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "1",
      "y1": "9",
      "x2": "4",
      "y2": "9"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "1",
      "y1": "14",
      "x2": "4",
      "y2": "14"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'download') ? _c('svg', {
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke-width": "1.5",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'duplicate') ? _c('svg', {
    staticClass: "feather feather-copy block mx-auto",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('rect', {
    attrs: {
      "x": "9",
      "y": "9",
      "width": "13",
      "height": "13",
      "rx": "2",
      "ry": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'edit') ? _c('svg', {
    staticClass: "feather feather-edit",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'eye') ? _c('svg', {
    staticClass: "feather feather-eye",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24px",
      "height": "24px",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "data-v-4c034fe6": "",
      "d": "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "data-v-4c034fe6": "",
      "cx": "12",
      "cy": "12",
      "r": "3"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'file') ? _c('svg', {
    staticClass: "feather feather-file",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "13 2 13 9 20 9"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'file-plus') ? _c('svg', {
    staticClass: "feather feather-file-plus",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "14 2 14 8 20 8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "18",
      "x2": "12",
      "y2": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "9",
      "y1": "15",
      "x2": "15",
      "y2": "15"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'film') ? _c('svg', {
    staticClass: "lucide lucide-book-open block mx-auto",
    class: _vm.classname,
    attrs: {
      "viewBox": "0 0 24 24",
      "width": "24",
      "height": "24",
      "stroke": "currentColor",
      "stroke-width": "2",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('rect', {
    attrs: {
      "x": "2",
      "y": "2",
      "width": "20",
      "height": "20",
      "rx": "2.18",
      "ry": "2.18"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "7",
      "y1": "2",
      "x2": "7",
      "y2": "22"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "17",
      "y1": "2",
      "x2": "17",
      "y2": "22"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "2",
      "y1": "12",
      "x2": "22",
      "y2": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "2",
      "y1": "7",
      "x2": "7",
      "y2": "7"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "2",
      "y1": "17",
      "x2": "7",
      "y2": "17"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "17",
      "y1": "17",
      "x2": "22",
      "y2": "17"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "17",
      "y1": "7",
      "x2": "22",
      "y2": "7"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'folder') ? _c('svg', {
    staticClass: "feather feather-folder",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'globe') ? _c('svg', {
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke-width": "1.5",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'grid') ? _c('svg', {
    staticClass: "icon-svg feather feather-grid",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24px",
      "height": "24px",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('rect', {
    attrs: {
      "data-v-4c034fe6": "",
      "x": "3",
      "y": "3",
      "width": "7",
      "height": "7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "data-v-4c034fe6": "",
      "x": "14",
      "y": "3",
      "width": "7",
      "height": "7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "data-v-4c034fe6": "",
      "x": "14",
      "y": "14",
      "width": "7",
      "height": "7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "data-v-4c034fe6": "",
      "x": "3",
      "y": "14",
      "width": "7",
      "height": "7"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'hard-drive') ? _c('svg', {
    staticClass: "feather feather-hard-drive",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('line', {
    attrs: {
      "x1": "22",
      "y1": "12",
      "x2": "2",
      "y2": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "6",
      "y1": "16",
      "x2": "6.01",
      "y2": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "10",
      "y1": "16",
      "x2": "10.01",
      "y2": "16"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'home') ? _c('svg', {
    staticClass: "feather feather-home",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "9 22 9 12 15 12 15 22"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'layers') ? _c('svg', {
    staticClass: "feather feather-layers",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polygon', {
    attrs: {
      "points": "12 2 2 7 12 12 22 7 12 2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "2 17 12 22 22 17"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "2 12 12 17 22 12"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'libraries') ? _c('svg', {
    staticClass: "lucide lucide-book-open block mx-auto",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'link') ? _c('svg', {
    staticClass: "feather feather-link",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24px",
      "height": "24px",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "data-v-4c034fe6": "",
      "d": "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "data-v-4c034fe6": "",
      "d": "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'mail') ? _c('svg', {
    staticClass: "feather feather-mail",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "22,6 12,13 2,6"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'minus') ? _c('svg', {
    staticClass: "feather feather-minus",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('line', {
    attrs: {
      "x1": "5",
      "y1": "12",
      "x2": "19",
      "y2": "12"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'moon') ? _c('svg', {
    staticClass: "css-i6dzq1",
    class: _vm.classname,
    attrs: {
      "viewBox": "0 0 24 24",
      "width": "24",
      "height": "24",
      "stroke": "currentColor",
      "stroke-width": "2",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'more-vertical') ? _c('svg', {
    staticClass: "feather feather-more-vertical",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "12",
      "cy": "5",
      "r": "1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "12",
      "cy": "19",
      "r": "1"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'newspaper') ? _c('svg', {
    staticClass: "w-6 h-6",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M4.125 3C3.089 3 2.25 3.84 2.25 4.875V18a3 3 0 003 3h15a3 3 0 01-3-3V4.875C17.25 3.839 16.41 3 15.375 3H4.125zM12 9.75a.75.75 0 000 1.5h1.5a.75.75 0 000-1.5H12zm-.75-2.25a.75.75 0 01.75-.75h1.5a.75.75 0 010 1.5H12a.75.75 0 01-.75-.75zM6 12.75a.75.75 0 000 1.5h7.5a.75.75 0 000-1.5H6zm-.75 3.75a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5H6a.75.75 0 01-.75-.75zM6 6.75a.75.75 0 00-.75.75v3c0 .414.336.75.75.75h3a.75.75 0 00.75-.75v-3A.75.75 0 009 6.75H6z",
      "clip-rule": "evenodd"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M18.75 6.75h1.875c.621 0 1.125.504 1.125 1.125V18a1.5 1.5 0 01-3 0V6.75z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'package') ? _c('svg', {
    staticClass: "feather feather-package",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('line', {
    attrs: {
      "x1": "16.5",
      "y1": "9.4",
      "x2": "7.5",
      "y2": "4.21"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "3.27 6.96 12 12.01 20.73 6.96"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "22.08",
      "x2": "12",
      "y2": "12"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'plus') ? _c('svg', {
    staticClass: "feather feather-plus",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('line', {
    attrs: {
      "x1": "12",
      "y1": "5",
      "x2": "12",
      "y2": "19"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "5",
      "y1": "12",
      "x2": "19",
      "y2": "12"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'refresh') ? _c('svg', {
    staticClass: "feather feather-refresh-cw",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "23 4 23 10 17 10"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "1 20 1 14 7 14"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'rocket') ? _c('svg', {
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke-width": "1.5",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M15.59 14.37a6 6 0 0 1-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 0 0 6.16-12.12A14.98 14.98 0 0 0 9.631 8.41m5.96 5.96a14.926 14.926 0 0 1-5.841 2.58m-.119-8.54a6 6 0 0 0-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 0 0-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 0 1-2.448-2.448 14.9 14.9 0 0 1 .06-.312m-2.24 2.39a4.493 4.493 0 0 0-1.757 4.306 4.493 4.493 0 0 0 4.306-1.758M16.5 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'search') ? _c('svg', {
    staticClass: "feather feather-search",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "11",
      "cy": "11",
      "r": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "21",
      "y1": "21",
      "x2": "16.65",
      "y2": "16.65"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'sun') ? _c('svg', {
    staticClass: "css-i6dzq1",
    class: _vm.classname,
    attrs: {
      "viewBox": "0 0 24 24",
      "width": "24",
      "height": "24",
      "stroke": "currentColor",
      "stroke-width": "2",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "5"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "1",
      "x2": "12",
      "y2": "3"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "21",
      "x2": "12",
      "y2": "23"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "4.22",
      "y1": "4.22",
      "x2": "5.64",
      "y2": "5.64"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "18.36",
      "y1": "18.36",
      "x2": "19.78",
      "y2": "19.78"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "1",
      "y1": "12",
      "x2": "3",
      "y2": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "21",
      "y1": "12",
      "x2": "23",
      "y2": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "4.22",
      "y1": "19.78",
      "x2": "5.64",
      "y2": "18.36"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "18.36",
      "y1": "5.64",
      "x2": "19.78",
      "y2": "4.22"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'table') ? _c('svg', {
    class: _vm.classname,
    attrs: {
      "viewBox": "0 0 24 24",
      "width": "24",
      "height": "24",
      "stroke": "currentColor",
      "stroke-width": "2",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'target') ? _c('svg', {
    staticClass: "feather feather-target",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "6"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "2"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'toggle-right') ? _c('svg', {
    staticClass: "feather feather-toggle-right",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('rect', {
    attrs: {
      "x": "1",
      "y": "5",
      "width": "22",
      "height": "14",
      "rx": "7",
      "ry": "7"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "16",
      "cy": "12",
      "r": "3"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'trash') ? _c('svg', {
    staticClass: "feather feather-trash",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "3 6 5 6 21 6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'triangle') ? _c('svg', {
    class: _vm.classname,
    attrs: {
      "viewBox": "0 0 24 24",
      "width": "24",
      "height": "24",
      "stroke": "currentColor",
      "stroke-width": "2",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'user') ? _c('svg', {
    staticClass: "feather feather-user",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "12",
      "cy": "7",
      "r": "4"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'users') ? _c('svg', {
    staticClass: "feather feather-users",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "9",
      "cy": "7",
      "r": "4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M23 21v-2a4 4 0 0 0-3-3.87"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16 3.13a4 4 0 0 1 0 7.75"
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e3b28372","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/partials/Icon.vue
// module id = 483
// module chunks = 1